module.exports = __webpack_public_path__ + "static/media/devices.5db93605.svg";